import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { app } from "./firebase";
import { doc, setDoc } from "firebase/firestore";
import { db } from "./firebase";

// Request FCM token and save to Firestore
export async function requestFCMToken(userId: string): Promise<string | null> {
  try {
    // Check if browser supports notifications
    if (!("Notification" in window)) {
      console.log("This browser does not support notifications");
      return null;
    }

    // Request notification permission
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Notification permission denied");
      return null;
    }

    // Get FCM messaging instance
    const messaging = getMessaging(app);

    // Get FCM token with VAPID key
    const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY;
    if (!vapidKey) {
      console.error("VAPID key not configured");
      return null;
    }

    // Register service worker
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    await navigator.serviceWorker.ready;
    
    // Send Firebase config to service worker
    if (registration.active) {
      registration.active.postMessage({
        type: 'INIT_FIREBASE',
        config: {
          apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
          authDomain: `${import.meta.env.VITE_FIREBASE_PROJECT_ID}.firebaseapp.com`,
          projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
          storageBucket: `${import.meta.env.VITE_FIREBASE_PROJECT_ID}.appspot.com`,
          messagingSenderId: import.meta.env.VITE_FIREBASE_APP_ID?.split(':')[0] || '',
          appId: import.meta.env.VITE_FIREBASE_APP_ID
        }
      });
    }
    
    const token = await getToken(messaging, {
      vapidKey: vapidKey,
      serviceWorkerRegistration: registration
    });

    if (token) {
      console.log("FCM Token obtained:", token.substring(0, 20) + "...");
      
      // Save token to Firestore
      const userRef = doc(db, "users", userId);
      await setDoc(userRef, {
        fcmToken: token,
        fcmTokenUpdatedAt: Date.now()
      }, { merge: true });
      
      return token;
    } else {
      console.log("No registration token available");
      return null;
    }
  } catch (error) {
    console.error("Error getting FCM token:", error);
    return null;
  }
}

// Listen for foreground messages
export function listenForMessages(callback: (payload: any) => void) {
  try {
    const messaging = getMessaging(app);
    
    return onMessage(messaging, (payload) => {
      console.log("Foreground message received:", payload);
      callback(payload);
      
      // Show browser notification if permission granted
      if (Notification.permission === "granted") {
        new Notification(payload.notification?.title || "TemizFilo", {
          body: payload.notification?.body || "Yeni bildiriminiz var",
          icon: "/icon-192.png",
          data: payload.data
        });
      }
    });
  } catch (error) {
    console.error("Error setting up message listener:", error);
    return () => {};
  }
}

// Check if FCM is supported
export function isFCMSupported(): boolean {
  return (
    "Notification" in window &&
    "serviceWorker" in navigator &&
    "PushManager" in window
  );
}
